import Immutable from 'immutable';

const state = {
  quote: Spree.quote,
};

if (Spree.quote_parameters) {
  state.parameters = Spree.quote_parameters;
}

if (Spree.initial_cart_data) {
  state.cart = Spree.initial_cart_data;
}

export default Immutable.fromJS(state);
